import { Navigate, Outlet } from "react-router-dom";
import { getAuthRole, isAuthenticated } from "../../../utils/auth";

export default function RequireAdmin() {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (getAuthRole() !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
